import { FC } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { UserAvatar } from "~/components/ui/user-avatar";
import { useCasePresence } from "~/features/case/hooks/useCasePresence";
import { useChatDocumentParams } from "~/helpers";

export const PresenceAvatars: FC = () => {
  const { caseId } = useChatDocumentParams();
  const { presentUsers } = useCasePresence(caseId);

  if (!presentUsers.length) return null;

  const top = presentUsers.slice(0, 3);

  return (
    <TooltipProvider>
      <div className="flex -space-x-1">
        {top.map((u) => (
          <Tooltip key={u.id}>
            <TooltipTrigger asChild>
              <UserAvatar
                name={u.name}
                size="sm"
                className="border-2 border-white"
              />
            </TooltipTrigger>
            <TooltipContent>
              <p>{u.name}</p>
            </TooltipContent>
          </Tooltip>
        ))}
        {presentUsers.length > 3 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-500 text-[9px] text-white border-2 border-white">
                +{presentUsers.length - 3}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{presentUsers.length - 3} more users</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
};
